module.exports = __webpack_public_path__ + "static/media/parrot.e4d958b3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/parrot.gif
// module id = 90
// module chunks = 0